/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { $ } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { htmlspecialchars, copyToClipboard } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { postToBackend } from './fetch-util.js';
import { showInfoToastWithLink } from './snackbar.js';

import { MPlugins } from './plugins.js';


export function register_std_permalinks_plugin() {

	MPlugins.register( [$], 'std-view-permalinks', function($) {
		return {
			type: 'MediaMetaViewContainer',
			getAdditionalContainerCssClasses: function() {
				return 'mmd-sticky-container';
			},
			getContainerDefaultOpened: function() {
				return true;
			},
			getContainerTitle: function() {
				return mjt('permalinks-meta-container-title');
			},
			getContainerViewSetupHtml: function() {
				return '';
			},
			setupContainerViewData: function( container, media_id, dtinfo ) {
				if( !dtinfo.is_latest_version ) {
					// no permalinks on older versions ...
					return;
				}
				const canEditPermalinks = !!dtinfo.r_edit;

				startProgress();
				let postdata = 'media_id='+encodeURIComponent(media_id);
				postToBackend( 'json/media/meta-permalinksinfo', postdata, function(j) {
					stopProgress();
					if( j && j.success && j.permalinks && j.permalinks.length ) {
						// console.log({w:'std-view-permalinks::setupContainerViewData', container, media_id, dtinfo, j });
						const $permaLinkContainerContent = container.find('.content');
						let html = '<table><tbody>';
						let even = true;
						for( const permalink of j.permalinks ) {
							const isOutdated = permalink.outdated ?? false;
							html += '<tr class="md-m md-avl md-e '+(even?'even':'odd')+(isOutdated?' inactive':'')+'">';
							html +=  '<th>'
										+htmlspecialchars(permalink.title,false,true)
										+'<small> ('+permalink.dlf_id+(isOutdated?' outdated!':'')+')</small>'
									+'</th>';
							html +=  '<td>';
							const url = permalink.url ?? null;
							if( url==null ) {
								if( canEditPermalinks ) {
									html += '<button class="permalink-create-button button-tertiary smaller" type="button" data-dlf-id="'+htmlspecialchars(permalink.dlf_id,true,true)+'">'
											+ '<span class="icon icon-expand"></span>'
											+ mjt('permalinks-create-link')
										+ '</button>';
								}
							} else {
								html += '<a class="link copybox" href="'+htmlspecialchars(url,true,true)+'" target="_blank" style="user-select:auto">'+htmlspecialchars(url,false,true)+'</a>';
							}
							html +=  '</td>';
							html += '</tr>';
							even = !even;
						}
						html += '</tbody></table>';
						$permaLinkContainerContent.html(html);

						// // move to after .media-status-container ..
						// container.siblings('.media-status-container').after(container);

						// show
						container.show();

						container
							.off('click.mjPermalinksMetaView')
							.on( 'click.mjPermalinksMetaView','.link.copybox',function(e) {
								const copyURL = $(e.currentTarget).text();
								e.preventDefault();
								e.stopPropagation();
								requestAnimationFrame( function() {
									let sel = window.getSelection();
									const isSelected = sel.containsNode(e.currentTarget.firstChild??e.currentTarget,true);
									if( !isSelected ) {
										sel.selectAllChildren(e.currentTarget);
										// link text not selected?
										// -> first click: select text and copy to clipboard
										sel.selectAllChildren(e.currentTarget);
										copyToClipboard(copyURL);
										showInfoToastWithLink( mjt('md-link-info','!'), copyURL );
									} else {
										sel.removeAllRanges();
										// link text is selected?
										// -> second click: open link
										let linkElem = document.createElement('A');
										linkElem.href = copyURL;
										linkElem.target = '_blank';
										document.documentElement.appendChild(linkElem);
										linkElem.click();
										linkElem.remove();
									}
								} );
							} )
							.on( 'click.mjPermalinksMetaView','.permalink-create-button',function(e) {
								const dlfId = $(e.currentTarget).data('dlf-id');
								startProgress();
								let create_postdata = 'media_id='+encodeURIComponent(media_id)+'&dlf_id='+encodeURIComponent(dlfId);
								copyToClipboard(
									postToBackend('json/permalink/asset-create',create_postdata,null,true)
										.then( (j) => {
											stopProgress();
											if( j.success ) {
												const permalink = j.newPermalink ?? {};
												const $newNode = $('<a class="link copybox" href="'+htmlspecialchars(permalink.url,true,true)+'" target="_blank" style="user-select:auto">'+htmlspecialchars(permalink.url,false,true)+'</a>');
												$(e.currentTarget).replaceWith($newNode);
												let sel = window.getSelection();
												sel.selectAllChildren($newNode[0]);
												showInfoToastWithLink( mjt('permalinks-link-created-and-copied','!'), permalink.url );
												return permalink.url; // <-- the link for copyToClipboard()
											}
											return '';
										} )
								);
							} );

					} else {
						container.hide();
					}
				}, true );
			}
		};
	} );

}

